import { BaseHub, tpOnError } from "./BaseHub";
import { IPlatformHubAction } from "./IActions/IPlatformHubAction";

export class PlatformHub extends BaseHub<IPlatformHubAction> {
    constructor(onError: tpOnError) {
        super(onError, "Hubs/Platform");
    }
    public readonly getPlatformStatus = () => this.hub.invoke<{ [K: number]: boolean; }>("GetPlatformStatus");
}
